<template>
    <servicos
        :permitirAprovar="$temAcessoView('GESCON-GEST-SERV-00')"
        :permitirReprovar="$temAcessoView('GESCON-GEST-SERV-00')"
        :permiteDetalhar="$temAcessoView('GESCON-GEST-SERV-00')"
        rotaDetalhar="Gescon_Gestores_Servicos_Detalhar"
        rotaListagem="Gescon_Gestores_Servicos_Listagem"
    ></servicos>
</template>

<script>
import ServicosServicos from './ServicosServicos'
import Servicos from '../../aprovadores/Comprometimentos'

export default {
    name: 'GestoresServicos',
    
    components: {
        Servicos
    },

    data() {
        return {
            servicosServicos: ServicosServicos
        }
    },

    provide() {
        return {
            servicosServicos: this.servicosServicos
        }
    }
}
</script>
